import '../style/carousel.css';

export default function Carousel({ children }: { children?: React.ReactNode }) {
    document.addEventListener("DOMContentLoaded", function () {


        const carousel = document.querySelector(".carousel");
        const wrapper = document.querySelector(".wrapper");

        const firstCard = carousel.querySelector(".card");
        const firstCardWidth = firstCard.offsetWidth;

        let isDragging = false,
            startX,
            startScrollLeft

        const dragStart = (e) => {
            isDragging = true;
            carousel.classList.add("dragging");
            startX = e.pageX;
            startScrollLeft = carousel.scrollLeft;
        };

        const dragging = (e) => {
            if (!isDragging) return;

            // Calculate the new scroll position
            const newScrollLeft = startScrollLeft - (e.pageX - startX);

            // Check if the new scroll position exceeds
            // the carousel boundaries
            if (newScrollLeft <= 0 || newScrollLeft >=
                carousel.scrollWidth - carousel.offsetWidth) {

                // If so, prevent further dragging
                isDragging = false;
                return;
            }

            // Otherwise, update the scroll position of the carousel
            carousel.scrollLeft = newScrollLeft;
        };

        const dragStop = () => {
            isDragging = false;
            carousel.classList.remove("dragging");
        };

        carousel.addEventListener("mousedown", dragStart);
        carousel.addEventListener("mousemove", dragging);
        document.addEventListener("mouseup", dragStop);


    });
    return (
        <div className="carouseldiv">
            <div className="wrapper">
                <ul className="carousel">
                    {children}
                </ul>
            </div>
        </div>
    )

}

export function Card({ header, roles, description, contribution, link }: { header: string, roles: string, description: string, contribution: string, link?: string }) {
    return (
        <li className="card">
            <h3 className="sub-header">{header}</h3>
            Roles: {roles}
            <ul className="cardlist">
                <li>{description}</li>
                <li>{contribution}</li>
            </ul>
            <a className="link" href={link}>Check it out!</a>
        </li>
    )
}

export function EndCard() {
    return (<li className="endcard"></li>)
}